import { useTranslation } from 'react-i18next';

import { Form, FormActions, Modal, TextAreaInput } from 'ui';

type P = {
  loading: boolean;
  onSubmit: (data: { reason: string }) => void;
};

const RequestToJoinForm = ({ loading, onSubmit }: P) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = (data: { reason: string }) => {
    onSubmit(data);
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <TextAreaInput
        input={{
          placeholder: t('Write your answer...'),
          required: true,
        }}
        item={{
          label: 'requestToJoinFormTextAreaLabel',
          name: 'reason',
        }}
      />
      <Modal.HugContent.Footer>
        <FormActions submit={{ children: t('Send'), loading }} />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default RequestToJoinForm;
